import React from "react";
import { NotificationContainer } from "@flixbus/honeycomb-react";
import AppToast from "./AppToast.component";
import type { AppToastProps } from "./AppToast.types";
import styles from "./AppToastsContainer.module.scss";

interface Props {
  toasts: AppToastProps[];
  removeToast: (id: number) => void;
}

// Honeycomb panels/dialogs sit at z-index 1209; raise the toast container so
// notifications stay visible while a panel is open.
const AppToastsContainer: React.FC<Props> = ({ toasts, removeToast }) => (
  <NotificationContainer
    aria-label="App notifications"
    position="top-right"
    extraClasses={styles.container}
  >
    {toasts.map((toast) => (
      <AppToast key={toast.id} toast={toast} onClose={removeToast} />
    ))}
  </NotificationContainer>
);

export default React.memo(AppToastsContainer);
